var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher"},_vm._l((_vm.languages),function(language){return _c('v-btn',{key:language.value,staticClass:"mr-2",attrs:{"outlined":"","small":""},on:{"click":function($event){return _vm.selectLanguage(language.value)}}},[_vm._v(_vm._s(language.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }